// Front/src/utils/generateScaleJson.js

// Generate JSON Data for a new scale
export const generateScaleJson = (formData, userId) => {
    const max = parseFloat(formData.maxValue);
    const min = parseFloat(formData.minValue);
    const e = parseFloat(formData.eValue);
    const d = parseFloat(formData.dValue);
    const n = parseInt(formData.nValue);

    const etoDRatio = (e / d === 1) ? "Equal" :
                      (e / d === 2) ? "TwoTimes" :
                      (e / d === 10) ? "TenTimes" : "Unknown";

    return {
        ScaleType: {
            Id: formData.catalogNumber,
            Model: formData.Model,
            Manufacturer: formData.Manufacturer,
            ScaleAccuracy: {
                WeightUnits: formData.weightUnits,
                Max: max,
                Min: min,
                MaxInGrams: formData.weightUnits === "kg" ? max * 1000 : max,
                MinInGrams: formData.weightUnits === "kg" ? min * 1000 : min,
                EInGrams: formData.weightUnits === "kg" ? e * 1000 : e,
                E: e,
                D: d,
                N: n,
                EtoDRatio: etoDRatio,
                AccuracyClass: ["ONE", "TWO", "THREE", "FOUR"][formData.accuracyClass - 1] || ""
            },
        },
        Owner: {
            Id: formData.clientId,
        },
        InternalId: formData.internalId,
        CalibrationInfo: null,
        IsActive: true,
        Note: formData.notes,
        Id: formData.serialNumber,
        PartitionKey: "Scale",
        AddedBy: {
            ApiUserId: userId,
            Date: new Date().toISOString()
        },
    };
};
